export const sum = (term1: number, term2: number): number => term1 + term2;

export const removeItems = <T>(list1: T[], list2: T[]): T[] => {
  const list3 = [...list1];
  list2.forEach(
    (item) => list3.includes(item) && list3.splice(list3.indexOf(item), 1),
  );
  return list3;
};
